<template>
	<div class="addPolicy">
		<a-tabs v-model="activeName">
			<a-tab-pane tab="政策发布" key="addPolicy"></a-tab-pane>
		</a-tabs>

		<a-form-model ref="ruleForm" :model="form" :rules="rules" :wrapper-col="{ style: 'width: 100%' }"
			labelAlign="left">
			<a-form-model-item ref="policyName" label="政策名称：" prop="policyName">
				<a-input v-model="form.policyName" @blur="onBlur" />
			</a-form-model-item>
			<a-form-model-item label="政策内容：" prop="policyContent">
				<wangEditor v-model="form.policyContent" />
			</a-form-model-item>
			<a-form-model-item label="申报时间：" required prop="applyDate">
				<a-range-picker v-model="form.applyDate" :disabled-time="disabledRangeTime" :show-time="showTime"
					value-format="YYYY-MM-DD HH:mm:ss" />
			</a-form-model-item>
			<a-form-model-item label="适用公司产业类别（多选）：" prop="industryType"
				:labelCol="{ style: 'width:248px;margin-right:20px' }">
				<a-checkbox :indeterminate="indeterminateIndustryType" :checked="checkAllIndustryType"
					@change="onCheckAllChangeIndustryType">
					全选
				</a-checkbox>
				<a-checkbox-group v-model="industryTypeList" :options="industryTypeOptions"
					@change="onChangeIndustryType" />
			</a-form-model-item>
			<a-form-model-item label="适用项目类别（多选）：" prop="projectType" :labelCol="{ style: 'margin-right:20px' }">
				<a-checkbox :indeterminate="indeterminateProjectType" :checked="checkAllProjectType"
					@change="onCheckAllChangeProjectType">
					全选
				</a-checkbox>
				<a-checkbox-group v-model="projectTypeList" :options="projectTypeOptions"
					@change="onChangeProjectType" />
			</a-form-model-item>
			<a-form-model-item label="申报条件：" prop="applyConditions">
				<a-input v-model="form.applyConditions" type="textarea" />
			</a-form-model-item>
			<a-form-model-item label="支持力度：" prop="supportFrom">
				<a-input v-model="form.supportFrom" type="textarea" />
			</a-form-model-item>
			<a-form-model-item label="申报材料：" prop="applyMaterials">
				<a-input v-model="form.applyMaterials" type="textarea" />
			</a-form-model-item>
			<a-form-model-item label="上传附件：" prop="uploadAttachment">
				<a-upload accept=".doc, .docx, .pdf, .xlsx" name="file" :multiple="true" :before-upload="beforeUpload"
					action="https://policytest.gongsibao.com/api/upload/appendFileUpload" @change="handleFileChange" :remove="removeFile"
					v-model="form.uploadAttachment" :default-file-list="defaultFileList">
					<a-button>
						<a-icon type="upload" />上传文件
					</a-button>
				</a-upload>
			</a-form-model-item>
		</a-form-model>

		<div class="operation">
			<a-button type="primary" style="margin-left: 10px" ghost :loading="loading" @click="onSubmit(2)">
				{{loading?'保存中':'保存'}}
			</a-button>
			<a-button type="primary" @click="save"> 保存并发布 </a-button>
		</div>

		<a-modal v-model="visible" title="政策发布" :footer="null" :centered="true">
			<span class="enterprise">发布时间：</span>
			<a-radio-group v-model="value" @change="onRadioChange">
				<a-radio :value="1"> 立即发布 </a-radio>
				<a-radio :value="2"> 设置发布时间 </a-radio>
			</a-radio-group>
			<div class="row">
				<a-date-picker v-if="value == 2" value-format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate"
					:disabled-time="disabledDateTime" show-time v-model="delayTime" @change="onChangeDelayTime" />
			</div>
			<div class="row">
				<a-button type="primary" @click="pushPolicy">
					<a-icon type="plus" />推送企业设置
				</a-button>
				<a-button style="margin-left: 10px" type="primary" :loading="loading" @click="handlePublish">
					<a-icon type="plus" />{{loading?'发布中':'不推送企业,发布政策'}}
				</a-button>
			</div>
			<policyPush :isPolicyPublish="true" ref="policyPush" :policyVisible.sync="policyVisible"
				:policyMessage="policyMessage" @refresh="$router.go(-1)">
			</policyPush>
		</a-modal>
	</div>
</template>

<script>
	import {
		listIndustryCategory,
		listItemCategory,
		appendFileUpload,
		policyCreate,
		findPolicy,
	} from "@/api/policyPublish";

	import {
		getDateDiff
	} from "@/utils";
	import moment from "moment";
	import policyPush from "@/components/policyPush";
	import wangEditor from "./wangeditor.vue";
	export default {
		name: "addPolicy",
		components: {
			wangEditor,
			policyPush,
		},
		computed: {
			policyMessage() {
				return [{
					id: this.policyId,
					jobName: this.form.policyName ? this.form.policyName : "",
					info: this.form.policyContent ? this.form.policyContent : "",
				}, ];
			},
		},
		created() {
			if (this.$route.query.id) {
				this.policyId = this.$route.query.id;
				this.findPolicyById(this.policyId);
			}
			this.getIndustryCategoryList();
			this.getItemCategoryList();
			//this.uploadFiles()
		},
		data() {
			return {
				indeterminateIndustryType: true,
				checkAllIndustryType: false,
				industryTypeOptions: [],
				industryTypeList: [],
				industryTypeParams: [],

				indeterminateProjectType: true,
				checkAllProjectType: false,
				projectTypeOptions: [],
				projectTypeList: [],
				projectTypeParams: [],

				policyVisible: false,
				policyId: "",
				delayTime: "",
				value: 1,
				visible: false,
				policyAttachmentList: [],
				fileList: [],
				uploading: false,
				loading: false, //加载状态
				defaultFileList: [],

				activeName: "addPolicy",
				showTime: {
					hideDisabledOptions: true,
					defaultValue: [
						moment("00:00:00", "HH:mm:ss"),
						moment("23:59:59", "HH:mm:ss"),
					],
				},

				form: {
					policyContent: "",
					policyName: "",
					applyDate: [],
					industryType: [],
					projectType: [],
					applyConditions: "",
					supportFrom: "",
					applyMaterials: "",
				},
				rules: {
					policyContent: [{
						required: true,
						message: "请输入政策内容",
						trigger: "change",
					}, ],
					policyName: [{
						required: true,
						message: "请输入政策名称",
						trigger: "blur",
					}, ],
					applyDate: [{
						required: true,
						message: "请选择申报时间",
						trigger: "change",
					}, ],
					industryType: [{
						type: "array",
						required: true,
						message: "请选择公司产业类别",
						trigger: "change",
					}, ],
					projectType: [{
						type: "array",
						required: true,
						message: "请选择适用项目类别",
						trigger: "change",
					}, ],
					applyConditions: [{
						required: true,
						message: "请输入申报条件",
						trigger: "blur",
					}, ],
					supportFrom: [{
						required: true,
						message: "请输入支持力度",
						trigger: "blur",
					}, ],
					applyMaterials: [{
						required: true,
						message: "请输入申报材料",
						trigger: "blur",
					}, ],
				},
			};
		},
		methods: {
			pushPolicy() {
				if (this.policyId) {
					this.policyVisible = true;
				} else {
					// 保存数据
					if (this.value === 2) {
						if (this.delayTime.length === 0) {
							this.$message.error("请设置发布时间！");
							return;
						}
					}
					this.industryTypeParams = [];
					for (let item of this.industryTypeList) {
						for (let i of this.form.industryType) {
							if (i.name == item) {
								delete i.id;
								this.industryTypeParams.push(i);
							}
						}
					}
					this.projectTypeParams = [];
					for (let item of this.projectTypeList) {
						for (let i of this.form.projectType) {
							if (i.name == item) {
								delete i.id;
								delete i.code;
								this.projectTypeParams.push(i);
							}
						}
					}
					let params = {
						applyConditions: this.form.applyConditions,
						applyEndTime: this.form.applyDate ? this.form.applyDate[1] : "",
						applyMaterials: this.form.applyMaterials,
						applyStartTime: this.form.applyDate ? this.form.applyDate[0] : "",
						delayTime: this.delayTime,
						id: this.policyId,
						industryKeyValues: this.industryTypeParams,
						partitionValueList: this.projectTypeParams,
						policyAttachmentList: this.policyAttachmentList,
						policyContent: this.form.policyContent,
						policyName: this.form.policyName,
						pushType: this.value,
						supportFrom: this.form.supportFrom,
					};
					policyCreate(params).then((res) => {
						if (res.data.id) {
							this.policyId = res.data.id;
							this.policyVisible = true;
						} else {
							this.$message.error("保存失败!");
						}
					});
				}
			},
			save() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						this.visible = true;
					}
				});
			},
			handlePublish() {
				this.visible = false;
				this.onSubmit();
			},
			onRadioChange(e) {
				console.log("radio checked", e.target.value);
			},
			onChangeIndustryType(industryTypeList) {
				this.indeterminateIndustryType = !!industryTypeList.length &&
					industryTypeList.length < this.industryTypeOptions.length;
				this.checkAllIndustryType =
					industryTypeList.length === this.industryTypeOptions.length;
			},
			onCheckAllChangeIndustryType(e) {
				Object.assign(this, {
					industryTypeList: e.target.checked ? this.industryTypeOptions : [],
					indeterminateIndustryType: false,
					checkAllIndustryType: e.target.checked,
				});
			},

			onChangeProjectType(projectTypeList) {
				this.indeterminateProjectType = !!projectTypeList.length &&
					projectTypeList.length < this.projectTypeOptions.length;
				this.checkAllProjectType =
					projectTypeList.length === this.projectTypeOptions.length;
			},
			onCheckAllChangeProjectType(e) {
				Object.assign(this, {
					projectTypeList: e.target.checked ? this.projectTypeOptions : [],
					indeterminateProjectType: false,
					checkAllProjectType: e.target.checked,
				});
			},
			onChangeDelayTime(value) {
				if (value) {
					let date = new Date(value);
					let currentDate = new Date();
					if (getDateDiff(currentDate, date)) {
						let min = date.getMinutes();
						let cmin = currentDate.getMinutes();
						if (Math.abs(min - cmin) < 5) {
							date.setMinutes(min + 5);
							//date.setSeconds(30);
							this.delayTime = date.Format("yyyy-MM-dd hh:mm:ss");
						}
					} else {
						this.delayTime = value;
					}
				}
			},
			findPolicyById(id) {
				findPolicy(id).then((res) => {
					Object.assign(this.form, res.data);
					this.form.applyDate[0] = res.data.applyStartTime;
					this.form.applyDate[1] = res.data.applyEndTime;
					this.policyAttachmentList = res.data.policyAttachmentList;
					let allFileList = res.data.policyAttachmentList;
					for (let index in allFileList) {
						this.defaultFileList.push({
							uid: index.toString(),
							name: allFileList[index].name,
							url: allFileList[index].url,
							status: "done",
						});
					}

					console.log(this.defaultFileList);
					for (let item of res.data.industryKeyValues) {
						this.industryTypeList = [...this.industryTypeList, item.value];
					}
					for (let item of res.data.partitionValueList) {
						this.projectTypeList = [...this.projectTypeList, item.value];
					}
				});
			},
			createPolicy(params) {
				this.loading = true;
				policyCreate(params).then((res) => {
					this.$message.success(res.data.message);
					if (res.data.id) {
						this.policyId = res.data.id;
					}
					this.$router.go(-1);
				}).finally(() => {
					this.loading = false;
				});
			},
			beforeUpload(file) {
				const type = file.name.split(".")[file.name.split(".").length - 1];
				const list = ["doc", "docx", "pdf", "xlsx"];
				const isDPX = list.includes(type);
				if (!isDPX) {
					this.$message.error("不支持的文件格式，禁止上传!");
				}
				return isDPX;
			},
			uploadFiles(file) {
				appendFileUpload(file).then(() => {});
			},
			getIndustryCategoryList() {
				listIndustryCategory().then((res) => {
					this.form.industryType = res.data;
					for (let item of res.data) {
						this.industryTypeOptions = [...this.industryTypeOptions, item.name];
					}
				});
			},
			getItemCategoryList() {
				listItemCategory().then((res) => {
					this.form.projectType = res.data;
					for (let item of res.data) {
						this.projectTypeOptions = [...this.projectTypeOptions, item.name];
					}
				});
			},
			onSubmit(type) {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						this.industryTypeParams = [];
						for (let item of this.industryTypeList) {
							for (let i of this.form.industryType) {
								if (i.name == item) {
									delete i.id;
									this.industryTypeParams.push(i);
								}
							}
						}
						this.projectTypeParams = [];
						for (let item of this.projectTypeList) {
							for (let i of this.form.projectType) {
								if (i.name == item) {
									delete i.id;
									delete i.code;
									this.projectTypeParams.push(i);
								}
							}
						}
						let params = {
							applyConditions: this.form.applyConditions,
							applyEndTime: this.form.applyDate ? this.form.applyDate[1] : "",
							applyMaterials: this.form.applyMaterials,
							applyStartTime: this.form.applyDate ? this.form.applyDate[0] : "",
							delayTime: this.delayTime,
							id: this.policyId,
							industryKeyValues: this.industryTypeParams,
							partitionValueList: this.projectTypeParams,
							policyAttachmentList: this.policyAttachmentList,
							policyContent: this.form.policyContent,
							policyName: this.form.policyName,
							pushType: type ? type : this.value,
							supportFrom: this.form.supportFrom,
						};
						this.createPolicy(params);
					} else {
						this.$message.error("您的信息填写不完整！");
						return false;
					}
				});
			},
			resetForm() {
				this.$refs.ruleForm.resetFields();
			},

			onBlur() {
				this.$refs.policyName.onFieldBlur();
			},

			handleFileChange(info) {
				console.log(this.policyAttachmentList);
				console.log(info.file);
				if (info.file.status && info.file.status === "done") {
					if (info.file.response.code == 0) {
						this.policyAttachmentList = [...this.policyAttachmentList, info.file.response.data];
						this.$message.success(`${info.file.name} 上传成功。`);
					} else if (info.file.response.code == -1) {
						this.$message.error(info.file.response.message);
					}
				} else if (info.file.status === "error") {
					//this.$message.error(`${info.file.name} 上传失败！`);
				}
				//   console.log(this.policyAttachmentList);
				//   console.log(this.defaultFileList);
			},
			removeFile(file){
				const temp = this.policyAttachmentList.filter(item => item.name !== file.name);
				this.policyAttachmentList = temp
			},
			moment,
			range(start, end) {
				const result = [];
				for (let i = start; i < end; i++) {
					result.push(i);
				}
				return result;
			},
			disabledDate(current) {
				// Can not select days before today and today
				// return current && current < moment().endOf("day");
				// Can not select days before today
				return current < moment().subtract(1, "day");
			},

			disabledDateTime(type) {
				let currentDay = new Date().getDay()
				let checkedDay = type._d.getDay()
				if(checkedDay>currentDay){
					return {
						disabledHours: () => [0],
						disabledMinutes: () => [0],
						disabledSeconds: () => [0],
					};
				}else{
					return {
						disabledHours: () => this.range(0, new Date().getHours()),
						disabledMinutes: () => this.range(0, new Date().getMinutes() + 5),
						disabledSeconds: () => [0, new Date().getSeconds()],
					};
				}
			},

			disabledRangeTime(_, type) {
				console.log(_, type);
				/* if (type === 'start') {
					return {
						disabledHours: () => this.range(0, 60).splice(4, 20),
						disabledMinutes: () => this.range(30, 60),
						disabledSeconds: () => [55, 56],
					};
				}
				return {
					disabledHours: () => this.range(0, 60).splice(20, 4),
					disabledMinutes: () => this.range(0, 31),
					disabledSeconds: () => [55, 56],
				}; */
			},
		},
	};
</script>

<style lang="less" scoped>
	.addPolicy {
		background-color: #fff;
		padding: 0 20px 0;

		::v-deep .ant-tabs-tab-active {
			font-weight: 500;
			color: #333;
			font-size: 16px;
			padding: 12px 0;
		}

		::v-deep .ant-tabs-bar {
			margin: 0 0 30px 0;
		}

		::v-deep .ant-tabs-ink-bar {
			width: 64px;
		}

		::v-deep .ant-form-item {
			display: flex;
		}

		::v-deep textarea.ant-input {
			height: 283px;
		}

		::v-deep .ant-form-item-label label {
			width: 82px;
			font-size: 16px;
			height: 22px;
			margin-right: 20px;
			font-weight: 600;
			color: #333333;
		}

		::v-deep .ant-checkbox-group-item{
			margin-top: 20px;
			margin-right: 30px;
		}

		::v-deep .ant-checkbox-indeterminate .ant-checkbox-inner::after {
			background-color: #ffffff;
		}

		.operation {
			display: flex;
			flex-direction: row-reverse;
			padding-bottom: 20px;
		}
	}

	::v-deep .ant-modal-content {
		.ant-modal-body {
			.row {
				text-align: center;
				margin-top: 20px;
			}
		}
	}
</style>
